import React, { Component } from 'react'

//css
import './stand.scss';

// react-$ColoBackgroundForm
//import { Link } from 'react-router-dom';

//bootstrap
import {Button} from 'reactstrap';

export class Stand extends Component {
  constructor(props){
    super(props);
    this.state = {
      standvis: false
    }
  }
  Visible(){
    this.setState(prevState => {
      return{standvis: !this.state.standvis}
    });
  }
  cotizacion(){

  }

  render() {
    return (
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178 178" onClick={()=>{this.Visible()}} >
            <defs>
            </defs>
            <title>Stand</title>
            <g id="Capa_22" data-name="Capa 2">
              <g id="Capa_1-2" data-name="Capa 1" className="cls-111">
              <circle className="cls-11 cls-111" cx="89" cy="89" r="87"/>
                <g className="cls-22 cls-111"><path className="cls-33 cls-111" d="M151.39,31.29l-.25,118.83s-1.82,2.42-12.73,0c0,0-41.8-16.15-118.8-11.77l.21-99.43S95,42.38,137.74,31.26C137.74,31.26,151.39,28,151.39,31.29Z"/><path className="cls-33 cls-111" d="M135.5,31.82V31.2l-6.2.61s-1.37-2.68-5.61-2.06c0,0-5-2.59-4.59,3l4.93-1V31s3.21-2.42,4.58,1l.23,1.3S135.49,32.45,135.5,31.82Z"/><path className="cls-33 cls-111" d="M112.46,36.76v-.85h-6.07s-2.28-3.16-5.61-2c0,0-4.57-3.79-4.81,2.85l5.27-1.13-.12-.82a3.13,3.13,0,0,1,4.58,1.4l-.12,1.26Z"/><path className="cls-33" d="M76.61,38.8s.35-1.66-3.2-1.44L72.73,36h.69s-1.37-3.29-3.66-3.25c0,0-3,.39-2.58,3h4.71l.84,3Z"/><path className="cls-33" d="M44.44,39.41s.35-1.19-3-1.19v-1.6h3S44,33.14,40.79,33.1c0,0-2.75-.5-2.64,3.62l2.63.58v.8l-.69.11V39.4Z"/>
                </g>
              </g>
            </g>
        </svg>
        <div className={(this.state.standvis? 'standvis' : 'standhidd')}>
          <h4>Stand</h4>
          <h6 >Un <strong>Stand</strong> versatil facil de transportar, adaptable a cualquier espacio y con gran funcionalidades para dar a conocer sus productos.</h6>
          <Button className="dats" to="/Stand" value={"Stand"} >Cotizar</Button>
        </div>
        <div className={"Standflexdirection"} >
          <Button color="info" to="/Stand" className="btnOption" onClick={()=> {this.Visible()}}>
            <i className="fas fa-angle-down" ></i>
          </Button>
        </div>
      </div>
    )
  }
}
export default Stand;



// WEBPACK FOOTER //
// ./src/Components/Section-Principal/stand/stand.jsx